// Types
import { TAuthState } from '@/types/store/state'
import { USER } from '@/types/store/const'

const INITIAL_STATE: TAuthState = {
  user: null,
  jwt: null,
}

export const authReducer: any = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case USER:
      return {
        ...state,
        user: action.payload.user,
        jwt: action.payload.jwt || null,
      }
    default:
      return state
  }
}
